/* eslint-disable */
const localization = {
    // This is the array of lexemes found in the app
    lexemes: [
      "Download on the App Store",
      "Meet nearby groups IRL",
      "Connect with your new crew in Hives.",
      "Find your kinda people",
      "Whatever your passion, there’s a Hive for you!",
      "A safe space to be you",
      "Choose from either Hidden or Discoverable Hives.",
      "Get started",
      "Whatever your passion, there’s a Hive for you",
      "Get to know a new group of people in Hives on Bumble BFF",
      "You’re invited to Hives",
      "Meet new groups of local people on Bumble BFF’s new feature, Hives. Create your BFF profile on the Bumble app today.",
      "Get it on Google Play",
      "Manage Cookies",
      "Gender Pay Gap",
      "Modern Slavery Statement",
      "Terms and Conditions",
      "About",
      "Life"
],

    // These are the common words found in the lexemes of the app
    common: {
      "day": {
            "plural": [
                  "days"
            ],
            "singular": [
                  "day"
            ]
      },
      "hour": {
            "plural": [
                  "hours"
            ],
            "singular": [
                  "hour"
            ]
      },
      "minute": {
            "plural": [
                  "minutes"
            ],
            "singular": [
                  "minute"
            ]
      },
      "month": {
            "plural": [
                  "months"
            ],
            "singular": [
                  "month"
            ]
      },
      "second": {
            "plural": [
                  "seconds"
            ],
            "singular": [
                  "second"
            ]
      },
      "year": {
            "plural": [
                  "years"
            ],
            "singular": [
                  "year"
            ]
      }
}
};

// In dev mode we extend lexemes to include the indexMap as well, in production it remains as an array
if (__DEV__) {
    // This is a map of lexeme ids to their index in the array, it's only needed during development
    const indexMap = require('./index-map').default;

    localization.indexMap = indexMap;

    Object.entries(localization.indexMap).forEach(([indexKey, indexValue]) => {
        localization.lexemes[indexKey] = localization.lexemes[indexValue];
    });
}

export default localization;
